<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/bg6.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1 class="title">
            Together, we will build a <br> supply chain system <br> tailored to your needs<span class="tpgreen">.</span class="tpgreen"></span>
          </h1>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="container">
        <div class="row elgrey">
          <div
            class="col-md-4 pophover elmaster"
            @click="$router.push('warehouse')"
          >
            <card style="min-height:500px">
              <img
                slot="image"
                class="card-img-top"
                :src="imgWare"
                alt="Card image cap"
              >              
              <h4 class="card-title">
                Warehousing and Distribution
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
              >
                From a simple and cost-effective warehousing solution to a long-term inventory management system, we commit to providing a customized approach through our fully secured premises.
              </p>              
            </card>
          </div>

          <div
            class="col-md-4 pophover elmaster"
            @click="$router.push('transportation')"
          >
            <card style="min-height:500px">
              <img
                slot="image"
                class="card-img-top"
                :src="imgTrans"
                alt="Card image cap"
              >              
              <h4 class="card-title">
                Transportation
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
              >
                Need to move a single pallet across town or an entire truckload across the country? Our reliable asset-based division offers flexible transport services.
              </p>              
            </card>
          </div>

          <div
            class="col-md-4 pophover elmaster"
            @click="$router.push('freightbrokerage')"
          >
            <card style="min-height:500px">
              <img
                slot="image"
                class="card-img-top"
                :src="imgFreight"
                alt="Card image cap"
              >            
              <h4 class="card-title">
                Freight Brokerage
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
              >
                Over the years, we have built strong partnerships in every point along the supply line that enables us to efficiently manage your product distribution. By assessing your needs, we provide custom solutions at competitive rates
              </p>              
            </card>
          </div>
        </div>
      </div>
    </div>


    <div class="gotoservices">
      <a href="/">Get a quote for your business  <span class="tpgreen">→</span></a>
    </div>
  </div>
</template>
<script scoped>
import { Card } from '@/components';

export default {
  components: { Card },
  data () {
    return {
      imgWare: "img/bg1.jpg",
      imgTrans: "img/bg4.jpg",
      imgFreight: "img/bg3.jpg",

    }
  }
};
</script>
<style>
.border{
  border-style: none;
}
.border:hover{
  border-style: dotted;
}


</style>
